import { render, staticRenderFns } from "./MedicoSolicitanteEditar.vue?vue&type=template&id=64a7cd7d"
import script from "./MedicoSolicitanteEditar.vue?vue&type=script&lang=js"
export * from "./MedicoSolicitanteEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports